import {
  Afs,
  AfsPageOptions,
  debugLog
} from '@schibsted-nmp/advertising-shared';

export function triggerAllAfsRequests(afs: Afs) {
  if (!afs.query) {
    return;
  }
  afs.placements.forEach((placement) => {
    if (placement.container === 'afs_container_2') {
      // NOTE: temporary fix until we support multiple placements
      return;
    }
    triggerAfsRequest({
      adPage: afs.adPage,
      pubId: afs.pubId,
      query: afs.query,
      container: placement.container,
      styleId: placement.styleId,
      number: 1
    });
  });
}

export function triggerAfsRequest({
  container,
  ...afsPageOptions
}: AfsPageOptions) {
  if (afsPageOptions.query) {
    debugLog(`Triggering AFS request for container: ${container}`);
    try {
      window._googCsa('ads', afsPageOptions, {
        container,
        adLoadedCallback: (...args) =>
          debugLog(`Arguments from adLoadedCallback: ${args}`)
      });
    } catch (error) {
      debugLog('Error in google ad sense [for search]: ', error);
    }
  }
}
